import { Site } from '@envato/foundation-types'
import * as React from 'react'
import { RouterAction } from 'react-router-redux'

import { ILocationParams } from '../../../common/reducers/reactRouterLocation'
import { hasFeature } from '../../../common/utils/features'
import { filterSortByOptions } from '../../../common/utils/item'
import { ICommonLocation } from '../../../common/utils/location/types'
import { getConfigBySite } from '../../../config/sites'
import siteDefaultConfigs from '../../../config/sites/defaults'
import Dropdown from '../../components/dropdown'
import ChevronDownIcon from '../../components/icons/chevronDown'

import { defaultSortOrderForSortExperiment } from '../../../common/actions/experiments'

import * as styles from './sortBy.module.css'

const searchQueryConfigs = siteDefaultConfigs.search_query
const defaultSortByOptions = searchQueryConfigs.default_sort_by_options

interface IProps {
  location: ICommonLocation
  locationParams: ILocationParams
  currentSite: Site
  makeSearchLink: (params: ILocationParams, currentSite?: Site) => string
  experiments: any
  push: (path: string) => RouterAction
}

/**
 * A sort by menu which has lots of business logic
 */
class SortByDropdown extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props)
    this.onSortBySelectionChange = this.onSortBySelectionChange.bind(this)
  }

  public render() {
    const { locationParams, currentSite, location, experiments } = this.props

    const sortByOptions = filterSortByOptions(
      currentSite,
      locationParams,
      defaultSortByOptions
    )
    const selectedSortByValue = this.getSelectSortByValue(
      locationParams,
      currentSite,
      location,
      experiments
    )

    // Append "Sort by:" to selected label
    const sortByOptionsWithLabel = sortByOptions.map(option => {
      if (option.value === selectedSortByValue) {
        return {
          ...option,
          label: `${option.label}`
        }
      } else {
        return option
      }
    })

    return (
      <div className={styles.sortByWrapper}>
        <label htmlFor="sortby" className={styles.sortByLabel}>
          Sort by:{' '}
        </label>
        <Dropdown
          id="sortby"
          name="sortby"
          className={styles.sortBySelect}
          options={sortByOptionsWithLabel}
          onChange={this.onSortBySelectionChange}
          value={selectedSortByValue}
        />
        <ChevronDownIcon
          width="22"
          height="14"
          className={styles.chevronIcon}
        />
      </div>
    )
  }

  private getSelectSortByValue(
    parsedLocation: ILocationParams,
    currentSite: Site,
    location: ICommonLocation,
    experiments: any
  ) {
    let sortOrder

    const experimentDefaultSort = defaultSortOrderForSortExperiment()

    const sortOrderExperimentEnabled = hasFeature(
      'defaultSort:enrolment',
      currentSite,
      location,
      experiments
    )

    if (parsedLocation.sort_by) {
      sortOrder =
        parsedLocation.sort_by === 'price' && parsedLocation.sort_direction
          ? 'price-' + parsedLocation.sort_direction
          : parsedLocation.sort_by
    } else if (parsedLocation.term) {
      sortOrder = 'relevance'
    } else if (sortOrderExperimentEnabled && experimentDefaultSort) {
      sortOrder = experimentDefaultSort
    } else {
      sortOrder = getConfigBySite(
        this.props.currentSite,
        'search_query.default_sort_by'
      )
    }

    return sortOrder
  }

  private onSortBySelectionChange(event: React.ChangeEvent<HTMLSelectElement>) {
    const { push, locationParams, makeSearchLink } = this.props

    const sort = event.target.value
    const newQuery: ILocationParams = {
      ...locationParams,
      sort
    }
    delete newQuery.sort_by
    delete newQuery.sort_direction

    push(makeSearchLink(newQuery, this.props.currentSite))
  }
}

export const SortByDropdownComponent = SortByDropdown
export default SortByDropdown
